<template>
  <b-table
      responsive="sm"
      :items="items"
      :fields="fields"
      striped="striped"
      bordered="bordered"
      hover="hover"
      table-variant="secondary"
  >
    <template v-for="(field, index) in fields"  v-slot:[`cell(${field.key})`]="data">
      <template v-if="field.key === 'age'">
        <span>{{ data.item[field.key] }}</span>
      </template>
      <template v-else>
        <b-form-input
            v-if="isInputEnabled(data.item.age, field.key)"
            v-model="data.item[field.key]"
            :id="`${field.key}-${data.index}`"
            placeholder=""
        />
        <b-form-input
            v-else
            :disabled="true"
            :id="`${field.key}-${data.index}`"
            placeholder=""
        />
      </template>
    </template>
  </b-table>
</template>

<script>
import { BTable, BFormInput } from 'bootstrap-vue';

export default {
  components: {
    BTable,
    BFormInput,
  },
  data() {
    return {
      items: [
        {
          age: 'Branco',
          pp: '',
          p: '',
          m: '',
          g: '',
          gg: '',
          xg: '',
          xgg: '',
          unico: '',
          outros: '',
        },
        {
          age: 'Preto',
          pp: '',
          p: '',
          m: '',
        },
        {
          age: 'Marinho',
          pp: '',
          p: '',
          m: '',
          g: '',
          gg: '',
          xg: '',
          xgg: '',
          unico: '',
          outros: '',
        },
      ],
      fields: [
        { key: 'age', label: 'Cor', sortable: true },
        { key: 'pp', label: 'PP', sortable: true },
        { key: 'p', label: 'P', sortable: true },
        { key: 'm', label: 'M', sortable: true },
        { key: 'g', label: 'G', sortable: true },
        { key: 'gg', label: 'GG', sortable: true },
        { key: 'xg', label: 'XG', sortable: true },
        { key: 'xgg', label: 'XGG', sortable: true },
        { key: 'unico', label: 'ÙNICO', sortable: true },
        { key: 'outros', label: 'OUTROS', sortable: true },
      ],
    };
  },
  methods: {
    isInputEnabled(age, size) {
      if (age === 'Branco' && (size === 'p' || size === 'gg')) return false;
      if (age === 'Preto' && (size === 'm' || size === 'gg')) return false;
      if (age === 'Marinho' && (size === 'p' || size === 'gg')) return false;
      return true;
    },
  },
};
</script>
